export const RETAIL_NAME = 'RETAIL';
